import { Radio, FormControlLabel, FormLabel } from '@mui/material';
import RadioGroup from '@mui/material/RadioGroup';
import React, { useState, useEffect } from 'react';
import { Box, Grid, TextField, Typography, MenuItem, Select, FormControl, InputLabel, Card } from '@mui/material';
import './Rampwalk.css';
import ReusableButton from '../Reusable/PrimaryButton/PrimaryButton';
import ButtonComponent from "../Reusable/PrimaryButton/PrimaryButton";
import Popup from "../Popup/GalleyPopup";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { enhancePrompt, generateVideo,  enhancePromptVariation} from "../../services/apiService";
import ErrorPopup from "../Popup/ErrorPopup/ErrorPopup";
import { showToast } from '../Toast/CommonToast';
import LoaderWithBackdrop from '../Loader/loader';
import { useReelsWebSocket } from '../../context/ReelWebSocketProvider';
import { useRambWalkWebSocket } from '../../context/RampWalkWebSocket';
import { useLocation } from 'react-router-dom';
import { useCreditPoints } from '../../services/CreditPointsProvider';
import ExistingUploadImages from '../ExistingImageContainer/ExistingUploadImages';

export default function PodcastGeneratorUI({ handleFileUpload, 
     
    image, setDragImage, dragImage, 
    handleRemove, setSelectedImageId, 
    selectedImageId, setPrompt, prompt,eventId,
    setVideoData, setImage,
    setQuotes, quotes, setDuration, duration,
    eventIdRes,
    animationLocation 
}: any) {
    const fileInputRef = React.useRef<HTMLInputElement | null>(null);
    const lastUploadedUrlRef = React.useRef<string | null>(null);
    const [openModel, setOpenModel] = useState<boolean>(false);
    const [selectionMode, setSelectionMode] = useState<'card' | 'image'>('card');
    const userId = localStorage.getItem("userId") || "";
    const [errorPopupOpen, setErrorPopupOpen] = useState({ open: false, message: "" });
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const {  fetchCreditPoints } = useCreditPoints();
    const [isAudioSound, setIsAudioSound] = useState<boolean>(true);

    const location = useLocation();

      const isReelsPage = location.pathname.startsWith('/studio/reels')
       const reelsWebSocket = useReelsWebSocket();
       const rampWalkWebSocket = useRambWalkWebSocket();
       const { reconnectWebSocket } = isReelsPage ? reelsWebSocket : rampWalkWebSocket

    const creditPoints = Array.isArray(eventIdRes) && eventIdRes.find((item: any) => item.eventName === "Ramp Walk")?.videoCreditsForduration;
    const creditPointsReels = Array.isArray(eventIdRes) && eventIdRes.find((item: any) => item.eventName === "Reels")?.videoCreditsForduration;

    const credits = isReelsPage
  ? (creditPointsReels?.[`${duration}s`] || 0) + (isAudioSound ? 50 : 0)
  : (creditPoints?.[`${duration}s`] || 0) + (isAudioSound ? 50 : 0);

    




    const handleButtonClick = () => {
        if (fileInputRef.current) {
            (fileInputRef.current as any).click();
        }
    };

    const handleGalleryImage = () => {
        setOpenModel(true);
        setSelectionMode('card');
        setSelectedImageId([]);
    }
    
    const handleEnhaceAI = async () => {
       try{
        const enhancePayload={
            prompt: prompt || selectedImageId?.prompt || '',
            eventId: eventId || '',
            imageUrl: dragImage || selectedImageId?.url || image || ''
        }
        const enhanceRes = await enhancePrompt(enhancePayload);
        setPrompt(enhanceRes?.data || '');
       }catch(error:any) {
        console.error("Error enhancing prompt", error);
        showToast(error?.message, "error");
        
       }
    };
            const handleVariationWithAI = async () => {
                setIsLoading(true);
                try {
                    const payloadVariation = {
                        prompt: prompt || selectedImageId?.prompt || '',
                        eventId: eventId,
                        imageUrl: dragImage || selectedImageId?.url || image || ''
                    };
                    const response = await enhancePromptVariation(payloadVariation);
                    setIsLoading(false);
                    if (response && response.status === "success") {
                        setPrompt(response.data); // Always set prompt
                        // Prevent uploadFile API from being called again for this prompt change
                        // by updating lastUploadedUrlRef to current url (if any)
                        if (selectedImageId?.url && lastUploadedUrlRef) {
                            lastUploadedUrlRef.current = selectedImageId.url;
                        }
                        showToast(response.message, "success");
                    } else {
                        showToast(response.message, "error");
                        setIsLoading(false);
                    }
                } catch (error: any) {
                    setIsLoading(false);
                    showToast(error.message, "error");
                }
            };



        // Generate Reels
    const handleGenerateReels = async()=>{
        reconnectWebSocket();
        setIsLoading(true);
        try{
            const payLoadReels ={
                userId: userId,
                videoPrompt: prompt || selectedImageId?.prompt || '',
                eventId: eventId || '',
                imageUrl: dragImage || selectedImageId?.url || image || '',
                needAudio: isAudioSound, // Pass selected audio URL
                text: quotes,
                duration: duration,
                animation: 'typewriter',
            }
            const payLoadRampWalk = {
                userId: userId,
                videoPrompt: prompt || selectedImageId?.prompt || '',
                eventId: eventId || '',
                imageUrl: dragImage || selectedImageId?.url || image || '',
                duration: duration,
                needAudio: isAudioSound,
            }
            const payload = isReelsPage ? payLoadReels : payLoadRampWalk;
            const response = await generateVideo(payload);
            setIsLoading(false);
            fetchCreditPoints(userId);
            const is404 = response?.statusCode === 404  || response?.errcode === "CRD404";
            const is403 = response?.statusCode === 403 || response?.errcode === "CRD403";
            if (response?.status === "success") {
                showToast(response?.message, "success");
                setVideoData(response?.data || []);
                setImage("");
                setDragImage("");
                setSelectedImageId(null);
                setPrompt("");
                 
            } else if (is404 || is403 || response?.errcode) {
                setErrorPopupOpen({
                    open: true,
                    message: response?.message || "Failed to generate reels.",
                });
            } else {
                showToast(response?.message || "Failed to generate reels.", "error");
            }
        }catch(error:any){
            setIsLoading(false);
            setErrorPopupOpen({
                open: true,
                message: error?.message || "Failed to generate reels.",
            });
            showToast(error?.message, "error");
        }
    }

    
useEffect(() => {
  if (selectedImageId) {
    if (selectedImageId?.prompt) {
      setPrompt(selectedImageId.prompt);
    }
    // Call upload file API when selectedImageId changes
    if (selectedImageId?.url) {
      fetch(selectedImageId.url)
        .then(res => res.blob())
        .then(blob => {
          const fileName = selectedImageId.url.split('/').pop() || 'image.jpg';
          const file = new File([blob], fileName, { type: blob.type });
          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(file);
          const event = { target: { files: dataTransfer.files } };
          handleFileUpload(event);
        });
    }
  }
}, [selectedImageId,  setPrompt]);



    return (
        <Grid item xs={12} className="upload-mainContainer">
            {isLoading && (
                <LoaderWithBackdrop open={isLoading}/>
            )}
           {(errorPopupOpen.open && (errorPopupOpen.message === "Credits not found" || errorPopupOpen.message === "Insufficient credits")) && (
                <ErrorPopup
                    open={errorPopupOpen.open}
                    message={errorPopupOpen.message}
                    onClose={() => setErrorPopupOpen({ open: false, message: "" })}
                />
            )}
            <Typography variant="h6" className="uploadTexts">
                Upload Image or Generate AI
            </Typography>
                        <Card
                            className="UploadCard"
                            onDrop={async (e) => {
                                e.preventDefault();
                                try {
                                    const data = e.dataTransfer.getData('application/json');
                                    if (data) {
                                        const image = JSON.parse(data);
                                        setSelectedImageId?.(image);
                                        setImage?.(image.url);
                                        setPrompt?.(image.videoPrompt || '');
                                    }
                                } catch (err) {
                                    // ignore
                                }
                            }}
                            onDragOver={e => e.preventDefault()}
                        >
                                {(dragImage || selectedImageId?.url || image)  ? (
                                        <>
                                                <img src={dragImage || selectedImageId?.url || image || ""} alt="Uploaded" style={{ width: '70%', height: '100%', objectFit: "contain" }} />
                                                <img src={'/assets/Deletedicon.svg'} alt="DeletedIcon" className="DeletedIcon" onClick={handleRemove} />
                                        </>
                                ) : (
                                        <Box className="uploadBox">
                                                <div>
                                                        <img src={'/assets/UploadIcon.svg'} alt="Upload Icon" className="uploadIcon" onClick={handleButtonClick} />
                                                        <Typography className="uploadText">Upload Image From</Typography>
                                                        <div className="containerbtn">
                                                                <ButtonComponent onClick={handleButtonClick} >Computer</ButtonComponent>
                                                                <ButtonComponent className="nonStyledbtn" onClick={handleGalleryImage} >Persona</ButtonComponent>
                                                        </div>
                                                        <input
                                                                type="file"
                                                                ref={fileInputRef}
                                                                style={{ display: "none" }}
                                                                accept="image/*"
                                                                onChange={handleFileUpload}
                                                                multiple={false}
                                                        />

                                                </div>

                                        </Box>
                                )}
                        </Card>
            <Box>
                <Box className='promptHeader'>
                    <div className='promptHeaderText'>
                        <img src={'/assets/scriptIcon.svg'} alt='scriptIcon' className='scriptIcon' />
                        <Typography variant='h6' gutterBottom className='uploadText'>{isReelsPage ? `Describe your Reels video` : `Describe your rampwalk video`}</Typography>
                    </div>
                    <div className='promptHeaderText'>
                        {/* <Chip label="Hedra 3" className="hedraStyle" size="medium" /> */}
                          <ReusableButton icon={<AutoAwesomeIcon className="variationIcon" />} onClick={handleVariationWithAI} disabled={!prompt || !image }>Variant with AI</ReusableButton>
                        <ReusableButton onClick={handleEnhaceAI} icon={<AutoAwesomeIcon className="enhanceIcon" />}
                        disabled={!prompt || !image }
                        >Enhance With AI</ReusableButton>
                    </div>
                </Box>
                <TextField fullWidth className='textField' variant='outlined' label='Enhance your character prompt with emotions and gestures...' multiline rows={prompt ? 3 : 2} sx={{ mt: 1 }}
                value={prompt}
                onChange={(e) => setPrompt(e.target.value)}
                
                />
            </Box>
            <Box className="upload-container" sx={{ marginTop: '20px' }}>
                {animationLocation && (
                    <Box className="width100 upload-text-field">
                    <TextField
                        fullWidth
                        placeholder="Write Quotes here..."
                        multiline
                        rows={3}
                        className="textField"
                        label="Quotes"
                        value={quotes}
                        onChange={(e) => setQuotes(e.target.value)}
                    />
                </Box>
                )}
                {/* {isReelsPage && (
                    <Box className={`upload-text-field ${animationLocation ? "width75" : "width100"}`}>
                    <Audio 
        handleGenerateAudio={handleGenerateAudio} 
        audioDetails={audioDetails} 
        responseData={responseData}
        selectedAudioIndex={selectedAudioIndex}
        setSelectedAudioIndex={setSelectedAudioIndex}
    />
                </Box>
                )} */}
            </Box>
            <Box className="upload-container" mb={2} mt={2}>
                <Box className="formControl">
                    <FormControl size='medium' variant="outlined" className='textField duration' fullWidth>
                        <InputLabel id="duration-label">Select Duration</InputLabel>
                        <Select
                            labelId="duration-label"
                            id="duration-select"
                            label="Select Duration"
                            defaultValue={"6"}
                            value={duration}
                            onChange={(e) => setDuration(e.target.value as number)}
                            
                        >
                            <MenuItem value={"6"}>5 sec</MenuItem>
                            <MenuItem value={"10"}>10 sec</MenuItem>
                        </Select>
                    </FormControl>
                          <FormControl component="fieldset" className='textField' fullWidth>
                        <FormLabel id="radio-group-label">Background music:</FormLabel>
                        <RadioGroup
                            row
                            aria-label="audio-boolean"
                            name="audio-boolean-group"
                            value={isAudioSound ? 'true' : 'false'}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setIsAudioSound(e.target.value === 'true' ? true : false)}
                        >
                            <FormControlLabel value="true" control={<Radio />} label="Yes"  />
                            <FormControlLabel value="false" control={<Radio />} label="No" />
                        </RadioGroup>
                    </FormControl>
                     
                </Box>
            <> {console.log("creditPoints", creditPoints)}</>
                <Box>
                   

                    <ReusableButton
                        onClick={handleGenerateReels}
                        disabled={
  !duration ||
  !prompt ||
  !(dragImage || image || (selectedImageId && selectedImageId.url))
}
                    >
                        {`Generate (${credits} Credits)`}
                    </ReusableButton>
                </Box>
            </Box>

            <Box className ={isReelsPage ? "reels-uploaded-images" : "rampwalk-uploaded-images"}>
                <ExistingUploadImages  modelId={eventId}  setImage={setImage} setPrompt={setPrompt} image={image}/>
            </Box>

            {openModel && (
                <Popup
                open={openModel}
                onClose={() => setOpenModel(false)}
                selectionMode={selectionMode}
                setSelectionMode={setSelectionMode}
                setSelectedImageId={setSelectedImageId}
                selectedImageId={selectedImageId}
                 />
            )}

        </Grid>
    );
}
